import { Controller } from "@hotwired/stimulus"
import cable from "shared/action_cable"

export default class extends Controller {
  static values = {
    draftSiteId: Number
  }

  connect() {
    this.subscription = cable.subscriptions.create({ channel: "Site::DraftSiteLogoChannel", id: this.draftSiteIdValue }, {
      received: (data) => this.onCableReceived(data)
    })
  }

  disconnect() {
    this.subscription.unsubscribe()
  }

  onCableReceived(data) {
    data.forEach((message) => {
      document.getElementById(message.target).outerHTML = message.html
    })
  }
}